import { all, compose, path, propEq } from "ramda"
import filterSchemabyField from "./filterSchemaByField"
import reflectValidationResult from "./reflectValidationResult"

export const doValidate = async (args) => {
  const { fieldProps, form } = args
  const { forminputdata } = form.props
  const { fieldPath } = fieldProps
  const validateValue = path(fieldPath, forminputdata)
  const validationSchema = form.state.rules
  const relevantRules = compose(filterSchemabyField(validationSchema))(fieldProps)
  const validators = relevantRules.map((rule) => ({
    ...rule,
    expected: rule.resolver({ value: validateValue, forminputdata })
  }))
  const isPassAll = all(propEq("expected", true), validators)
  return {
    expected: isPassAll,
    validators
  }
}

const handleFieldValidation = async (args) => {
  const validationResult = await doValidate(args)

  return reflectValidationResult(args)(validationResult)
}

export default handleFieldValidation
